<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.abm.folders.modals.generic.title')"
    @close="closeDialog" max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex items-center px-10 py-16">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"
          />
        </div>
        <div>
          <p class="legend-xl mb-4">
            {{ message }}
          </p>
          <p class="text-custom-legend text-zt-dark-400" v-if="description">
            {{ description }}
          </p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-end items-center p-4"
      >
        <zt-button
          class="button-go-out"
          @click="closeDialog"
          data-vs-button="closeDialog"
        >
          {{ $t('message.abm.folders.modals.generic.buttonPrimary') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: 'ErrorDialog',
  inject: [ 'activeErrorDialog' ],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    returnToBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.activeErrorDialog(false)
      if (this.returnToBack) this.$router.push({
        id: this.$route.params.id,
        name: 'subfolder',
      })
    }
  }
}
</script>

<style scoped lang="scss">
.warning-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid #FB8C00;
  color: #FB8C00;
}
.warning-icon i {
  font-size: 2.438rem;
}
.legend-xl {
  font-size: 1.5rem;
  color: #4F4F4F;
  line-height: 1.3;
}
.legend-sm {
  font-size: 1.125rem;
  color: #4F4F4F;
  line-height: 1;
}
.zt-modal-footer {
  background-color: #EEEEEE;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  .button-go-out {
    color: #FFF!important;
    font-size: 1.125rem;
    &:hover {
      color: #FFF;
      background: #6452D3;
    }
  }
  button.button-cancel {
    font-size: 1.125rem;
    color: #707070!important;
    background-color: transparent!important;
  }
}
</style>
